export { DimmerComponent } from './dimmer.component';
export { L_DimmerModule } from './dimmer.module';



// WEBPACK FOOTER //
// ./.tmp/dimmer/index.ts